module.exports = __webpack_public_path__ + "static/img/zhaoshang.c0735aaf.png";